/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseregistrationEnrollmentBatchStatusChange202,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange400,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange401,
  PostApiV1CourseregistrationEnrollmentBatchStatusChange500,
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest,
  PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentBatchStatusChange.ts";
import { courseRegistrationBatchChangeStatusRequestViewModelSchema } from "../courseRegistrationBatchChangeStatusRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1CourseregistrationEnrollmentBatchStatusChange202Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChange202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseregistrationEnrollmentBatchStatusChange400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChange400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseregistrationEnrollmentBatchStatusChange401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChange401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseregistrationEnrollmentBatchStatusChange500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChange500>;

export const postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequestSchema =
  z.lazy(
    () => courseRegistrationBatchChangeStatusRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationRequest>;

export const postApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponseSchema =
  z.lazy(
    () => postApiV1CourseregistrationEnrollmentBatchStatusChange202Schema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentBatchStatusChangeMutationResponse>;
